// static data
import { GameConfig } from "Data/GameConfig";

// pubsub topics
import { ITEM_FOUND } from "Data/Topics";

// library functions
import { makeSprite } from "html-living-framework/lib/Utils/PixiUtils";
import { isMobile } from "html-living-framework/lib/Utils/PlatformUtils";

// framework stuff
import { Application } from "Application";
import { PixelPerfectHitArea } from "html-living-framework/lib/Input";

// types and interfaces
import type { ItemID } from "Data/GameConfig";
import type { IHiddenItemConfig } from "Interfaces/IHiddenItemConfig";
import type { IItemState } from "Interfaces/IItemState";
import type { ILevelState } from "Interfaces/ILevelState";
import type { ILocationConfig } from "Interfaces/ILocationConfig";

// singleton
import { GameState } from "Models/GameState";

export class HiddenItem extends PIXI.Container {

    public get found() { return this._found; }
    public get offset() { return this.spriteContainer.position; }
    public get scale() { return this.spriteContainer.scale; }
    public get rotation() { return this.spriteContainer.rotation; }
    public readonly id: ItemID;
    public readonly sprite: PIXI.Sprite;
    public readonly photoMode: boolean;

    protected spriteContainer: PIXI.Container;
    protected _found: boolean;
    private readonly _subscriptions: any[] = [];

    constructor(
        config: IHiddenItemConfig,
        state: ILevelState,
    ) {
        super();
        this.id = (typeof(config.item) === "string" ? config.item : config.item.id) as ItemID;
        this.name = this.id;
        this._found = state.items[this.id]!.found;

        const currentLocation = state.id;
        const levelConfig: ILocationConfig = GameConfig.locations[currentLocation];
        const itemConfig = levelConfig.items[this.id];

        this.sprite = makeSprite(currentLocation + "/" + itemConfig.sprite, GameConfig.spritesheets[currentLocation]);
        this.spriteContainer = this.addChild(new PIXI.Container());

        if (typeof(config.item) !== "string") {
            const item: {
                position?: {x: number, y: number},
                rotation?: number;
                scale?: number,
                flipX?: boolean,
            } = config.item;

            if (item.position !== undefined) {
                this.spriteContainer.position.set(item.position.x, item.position.y);
            }
            if (item.rotation !== undefined) {
                this.spriteContainer.rotation = item.rotation * PIXI.DEG_TO_RAD;
            }
            if (item.scale !== undefined) {
                this.spriteContainer.scale.set(item.scale);
            }
            if (item.flipX) {
                this.spriteContainer.scale.x *= -1;
            }
        }

        this.spriteContainer.addChild(this.sprite);

        this.photoMode = itemConfig.photoMode ?? false;

        this.interactive = true;
        this.buttonMode = true;
        this.interactiveChildren = true;
        this.spriteContainer.interactiveChildren = true;
        this.sprite.interactive = true;

        if (isMobile()) {
            const radius = Math.max(
                100 / Math.abs(this.scale.y),
                this.spriteContainer.width,
                this.spriteContainer.height,
            );
            this.sprite.hitArea = new PIXI.Circle(0, 0, radius);
        }
        else {
            this.sprite.hitArea = new PixelPerfectHitArea(Application.instance.renderer, this.sprite, 0);
        }

        const hs = config.hidingspot;

        if (typeof(hs) === "string") {
            this.on("pointertap", () => GameState.Instance.SearchHidingSpot(hs));
        }
        else {
            this.on("pointertap", () => GameState.Instance.SearchHidingSpot(hs.id));
        }

        this._subscriptions.push(
            PubSub.subscribe(ITEM_FOUND, this.onItemFound.bind(this)),
        );

        if (this._found) {
            this.interactive = false;
            this.interactiveChildren = false;
            // @ts-ignore
            this.hitArea = null;
            this.visible = false;
        }
    }

    public destroy(pOptions ?: PIXI.DestroyOptions | boolean) {
        this._subscriptions.forEach(PubSub.unsubscribe);
        super.destroy(pOptions);
    }

    protected DoFoundAnimation() {
        this.visible = false;
        if (this.photoMode) {
/*
            const mask = new PIXI.Graphics();
            mask.beginFill(0xff00000);
            mask.drawRect(
                -this.sprite.width / 2,
                -this.sprite.height / 2,
                this.sprite.width,
                this.sprite.height);
            mask.endFill();
            mask.position.copy(this.position);
            this.spriteContainer.addChild(mask);
            this.sprite.mask = mask;
            TweenLite.to(this.sprite, 1, {
                pixi: {
                    anchorY: -0.5,
                    // alpha: 0,
                },
            }).delay(3);
*/
        }
        else {
            //
        }
    }

    private onItemFound(pEvent: typeof ITEM_FOUND, state: IItemState) {
        if ( state.id !== this.id) { return; }

        if (this.found) {
            return;
        }

        this.interactive = false;
        this.interactiveChildren = false;
        // @ts-ignore
        this.hitArea = null;

        this.DoFoundAnimation();
        this._found = true;
    }
}
